/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromGetHighlights from 'app/library/store/actions/get-library-highlights.action';

export interface GetLibraryHighlightsState {
  libraryHR: any;
  lastViewedHrId: number | null;
  errorMessage: string;
  success: boolean;
  loading: boolean;
}

export const initialState = {
  libraryHR: null,
  lastViewedHrId: null,
  errorMessage: null,
  success: false,
  loading: false,
};

export function reducer(
  state = initialState,
  action: fromGetHighlights.GetLibraryHighlightsAction
): GetLibraryHighlightsState {
  switch (action.type) {
    case fromGetHighlights.GET_LIBRARY_HIGHLIGHTS: {
      return {
        ...state,
        libraryHR: null,
        errorMessage: null,
        loading: true,
        success: false,
      };
    }

    case fromGetHighlights.GET_LIBRARY_HIGHLIGHTS_FAIL: {
      return {
        ...state,
        libraryHR: null,
        errorMessage: action.payload,
        loading: false,
        success: false,
      };
    }

    case fromGetHighlights.GET_LIBRARY_HIGHLIGHTS_SUCCESS: {
      return {
        ...state,
        libraryHR: action.payload,
        errorMessage: null,
        loading: false,
        success: true,
      };
    }

    case fromGetHighlights.ADD_TO_LIBRARY_HIGHLIGHTS: {
      return {
        ...state,
        libraryHR: [...state.libraryHR, action.payload],
        errorMessage: null,
        loading: false,
        success: true,
      };
    }

    case fromGetHighlights.RESET_LIBRARY_HIGHLIGHTS: {
      return {
        ...initialState,
      };
    }

    case fromGetHighlights.SET_LAST_VIEWED_HR: {
      return {
        ...state,
        lastViewedHrId: action.payload,
      };
    }
  }

  return state;
}

export const getHighlightsData = (state: GetLibraryHighlightsState) => state.libraryHR;
export const getHighlightsErrorMessage = (state: GetLibraryHighlightsState) => state.errorMessage;
export const getHighlightsLoading = (state: GetLibraryHighlightsState) => state.loading;
export const getHighlightsSuccess = (state: GetLibraryHighlightsState) => state.success;
